import { fetchUserCampaigns } from '../api/campaigns';

import { GET_USER_CAMPAIGNS_SUCCESS } from '../constants/campaigns';

export const getUserCampaigns = () => async (dispatch) => {
  const userCampaigns = await fetchUserCampaigns();

  dispatch({
    type: GET_USER_CAMPAIGNS_SUCCESS,
    payload: userCampaigns
  });
};
